import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FlameAnimationComponent } from "./flame-animation.component";

@NgModule({
  declarations: [FlameAnimationComponent],
  imports: [CommonModule],
  exports: [FlameAnimationComponent],
})
export class FlameAnimationModule {}
